import React from "react";

const Title = () => {
  return (
    <>
      <h1> World Weather</h1>
    </>
  );
};

export default Title;
